import { Component, OnDestroy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-show-reply-modal',
    templateUrl: './show-reply-modal.component.html',
    styleUrls: ['./show-reply-modal.component.scss'],
    imports: [TranslateModule, FormsModule],
})
export class ShowReplyModalComponent implements OnDestroy {
    confirmCallback: (isUserBlocked: boolean) => void;
    isUserUnblock = false;
    onClose: Subject<boolean> = new Subject();

    constructor(private modalRef: BsModalRef) {}

    confirm(): void {
        this.onClose.next(true);
        this.onClose.complete();

        if (this.confirmCallback) {
            this.confirmCallback(this.isUserUnblock === true ? false : null);
        }

        this.modalRef.hide();
    }

    decline(): void {
        this.modalRef.hide();
    }

    ngOnDestroy() {
        this.onClose.next(false);
        this.onClose.complete();
    }
}
